import {
    DialogPositioningBehavior,
    DialogProps,
    DialogType,
    DialogWidget
  } from '@tableau/widgets';
  import React from 'react';

  import { Messages } from '~src/codegen/Localize';
  import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
  import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { KMSKeyHistoryTable } from '../components/KMSKeyHistoryTable';


export const openKMSKeyHistoryDialog = (externalKeyId: string): void => {
      ReactModalService.openCustom(closeAndDismiss => {
          const dialogProps = ReactModalService.getDefaultDialogProps({
              type: DialogType.NormalWithTitleBar,
              title: Messages.extractEncryption_KMSKeyHistoryDialog_Title(),
              testId: 'kms-key-policy-dialog',
              showCloseButton: true,
              dialogWidth: TabDialogWidth.width700px,
              dialogHeight: TabDialogWidth.width400px,
              positioningBehavior: DialogPositioningBehavior.Draggable,
              shouldNotCloseOnGlassClick: true
          }, closeAndDismiss);
          return getDialogWidget(dialogProps, closeAndDismiss, externalKeyId);
      });

  };


  function getDialogWidget(dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss, externalKeyId: string) {
    return (
      <DialogWidget {...dialogProps}>
        {<KMSKeyHistoryTable closeDialog={closeAndDismiss} externalKeyId={externalKeyId} />}
      </DialogWidget>
    );
  }